import type { AbilityBuilder } from '@casl/ability';

import { UserCaslRole } from ':constants/index';
import { CaslAction, CaslSubject } from ':helpers/casl/casl.enum';
import { userCaslPermissions, UserPermission, type UserPermissionArgs } from ':helpers/casl/permissions';

type CanFunction = AbilityBuilder<any>['can'];

export const userAbilities: Record<UserCaslRole, (user: UserPermissionArgs, can: CanFunction) => any> = {
    [UserCaslRole.ADMIN]: (_user: UserPermissionArgs, can: CanFunction) => {
        can(CaslAction.MANAGE, CaslSubject.ALL);
    },
    [UserCaslRole.OWNER]: (user: UserPermissionArgs, can: CanFunction) => {
        can(...userCaslPermissions(UserPermission.MANAGE_ORGANIZATION_USER_RESTAURANT, user));
        can(...userCaslPermissions(UserPermission.CREATE_ORGANIZATION_USER, user));
        can(...userCaslPermissions(UserPermission.MANAGE_ORGANIZATION_USER_CASL_ROLE, user));
        can(...userCaslPermissions(UserPermission.CREATE_ORGANIZATION_RESTAURANT, user));
        can(...userCaslPermissions(UserPermission.MANAGE_ORGANIZATION_CREDENTIALS, user));
        can(...userCaslPermissions(UserPermission.DELETE_ORGANIZATION_USER, user));
    },
    [UserCaslRole.GUEST]: (_user: UserPermissionArgs, _can: CanFunction) => {
        // No additional permissions
    },
};
